<div [formGroup]="addBoxesToContractForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Boxes</mat-label>
    <mat-select [(value)]="selectedBoxes" formControlName="boxes" multiple name="boxes">
      <mat-option *ngIf="!loadingBoxes && boxes.length === 0">
        No boxes available.
      </mat-option>
      <mat-option *ngFor="let box of boxes" [value]="box">
        {{box?.identifier}}
      </mat-option>
    </mat-select>
    <span *ngIf="loadingBoxes" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-hint *ngIf="!loadingBoxes && boxes.length === 0" class="color-warn">
      No boxes available.
    </mat-hint>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="contract = _contract; canceled.emit()" mat-button>Cancel</button>
    <button (click)="addBoxes()" [disabled]="addBoxesToContractForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>